import Button from '@rio-cloud/rio-uikit/Button';
import { useState } from 'react';

import { useClearDemoDataMutation } from '../../services/scmMockApi';

type Props = {
    disabled: boolean;
    onBusyChange: (busy: boolean) => void;
    onCleared: () => void;
};

export default function ResetDemoData({ disabled, onBusyChange, onCleared }: Props) {
    const [confirming, setConfirming] = useState(false);
    const [error, setError] = useState('');
    const [clear, { isLoading }] = useClearDemoDataMutation();
    const reset = async () => {
        if (disabled || isLoading) {
            return;
        }
        onBusyChange(true);
        setError('');
        try {
            await clear({ confirmation: 'DELETE_ALL_DEMO_DATA' }).unwrap();
            onCleared();
            setConfirming(false);
        } catch {
            setError('Clear not confirmed. Try again to delete the current demo data.');
        } finally {
            onBusyChange(false);
        }
    };
    return (
        <div className='scm-demo-reset'>
            {confirming ? (
                <>
                    <strong>Clear all demo data?</strong>
                    <p>Deletes all requests and transports for everyone in this environment. Cannot be undone.</p>
                    <div className='scm-demo-reset-actions'>
                        <Button disabled={disabled || isLoading} onClick={() => setConfirming(false)}>
                            Cancel
                        </Button>
                        <Button bsStyle={Button.DANGER} disabled={disabled || isLoading} onClick={reset}>
                            {isLoading ? 'Clearing…' : 'Delete everything'}
                        </Button>
                    </div>
                    {error && <p role='alert'>{error}</p>}
                </>
            ) : (
                <Button variant={Button.VARIANT_LINK} disabled={disabled} onClick={() => setConfirming(true)}>
                    Clear all demo data
                </Button>
            )}
        </div>
    );
}
